module.exports = __webpack_public_path__ + "img/talk-ticket-top-img.0d4bb77d.png";